import merge from "lodash.merge"
import sendStats from "@resources/js/components/stats";
import { PROMOTION_TYPES, DEFAULT_PROMOTION_ACTIONS } from "@resources/js/components/promotion/config"


const beforeActionCb = ({type, partnerUrl}) => {
    sendStats({type, partnerUrl})
}

const promotion = (customPromotionActions={}) => {
    const promotionActions = merge(DEFAULT_PROMOTION_ACTIONS, customPromotionActions)

    Object.entries(promotionActions).forEach(([actionType, action]) => {
        if (!action.active) return

        const actionPartnerUrl = PROMOTION_TYPES[action.type].generateLink({type: actionType})

        action.init({
            partnerUrl: actionPartnerUrl,
            beforeActionCallback: ({type=actionType, partnerUrl=actionPartnerUrl} = {}) => {
                beforeActionCb({type, partnerUrl})
            }
        })
    });
}

export default promotion
